import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { ApprovalRules } from 'ui-product-approvals-common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalRulesRadioGroup = ({
  name,
  label,
  value,
  onChange,
  hasOrderedApprovalSteps = false,
  required = false,
  labelAction,
  disabled = false
}) => /*#__PURE__*/_jsx(FormControl, {
  required: required,
  label: labelAction ? /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "between",
    children: [label, labelAction]
  }) : label,
  children: /*#__PURE__*/_jsxs(ToggleGroup, {
    name: name,
    children: [/*#__PURE__*/_jsx(RadioInput, {
      "data-test-id": "approval-rules-non-sequential",
      checked: value === ApprovalRules.NON_SEQUENTIAL,
      value: ApprovalRules.NON_SEQUENTIAL,
      description: /*#__PURE__*/_jsx(Small, {
        use: "help",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: hasOrderedApprovalSteps ? 'productApprovals.ApprovalRules.radioAllHelpOrdered' : 'productApprovals.ApprovalRules.radioAllHelp'
        })
      }),
      onChange: () => onChange(ApprovalRules.NON_SEQUENTIAL),
      disabled: disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalRules.radioAll"
      })
    }), /*#__PURE__*/_jsx(RadioInput, {
      "data-test-id": "approval-rules-any-can-approve",
      checked: value === ApprovalRules.ANY_CAN_APPROVE,
      value: ApprovalRules.ANY_CAN_APPROVE,
      description: /*#__PURE__*/_jsx(Small, {
        use: "help",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: hasOrderedApprovalSteps ? 'productApprovals.ApprovalRules.radioAny.helpOrdered' : 'productApprovals.ApprovalRules.radioAny.help'
        })
      }),
      onChange: () => onChange(ApprovalRules.ANY_CAN_APPROVE),
      disabled: disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: hasOrderedApprovalSteps ? 'productApprovals.ApprovalRules.radioAny.mainOrdered' : 'productApprovals.ApprovalRules.radioAny.main'
      })
    })]
  })
});